export enum SignalSource {
  Default = 'default',
  Full = 'full',
  Playback = 'playback',
  PlaybackLoop = 'playback-loop',
  Seconds15Loop = '15-secs-loop',

  GlitchOne = 'glitch1',
  GlitchTwo = 'glitch2',

  RandomOne = 'random1',
  RandomTwo = 'random2',

  BeatSmooth = 'beat-smooth',
  BeatNormal = 'beat-normal',
  BeatSharp = 'beat-sharp',

  FrequencesLow = 'frequencies-low',
  FrequencesMidLow = 'frequencies-midlow',
  FrequencesMidHigh = 'frequencies-midhigh',
  FrequencesHigh = 'frequencies-high'
}

export const isSoundtrackSignal = (signal: SignalSource): boolean => {
  return signal.startsWith('beat-') || signal.startsWith('frequencies-');
};



// WEBPACK FOOTER //
// ./src/data/SignalSource.ts